export const mobileAppCat = ["iOS", "Android", "phoneGap", "React Native", "openGl", "Ionic"]
export const frontendCat = ["Javascript", "AngularJs", "ReactJs", "Bootstrap", "Jquery", "ui"]
export const backendCat = ["Python", "Golang", "Java", "R", "Ruby on Rails", "DJango"]